import { L10n } from "client/utils/branding";
import { Translate } from "client/utils/internationalization";

import { FAQ } from "./types";

export const getLinkYourBankFaqs = (
  { brandTitle }: L10n,
  t: Translate
): FAQ[] => [
  {
    question: t("uiFaqLinkYourBankReceivePaymentsQuestion"),
    answer: t("uiFaqLinkYourBankReceivePaymentsAnswer", { brandTitle }),
  },
];
